import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';

export default function FloatingDonate() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="floating-donate"
          href="#donate"
          initial={{ opacity: 0, y: 20, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.85 }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-saffron-500 to-maroon-600 px-5 py-3.5 text-white shadow-[0_18px_40px_-12px_rgba(255,103,31,0.7)] hover:shadow-[0_24px_50px_-12px_rgba(107,26,36,0.8)] transition-all"
        >
          <span className="absolute inset-0 -z-10 rounded-full bg-saffron-500 opacity-50 animate-pulse-glow" />
          <Heart className="h-4 w-4 fill-white" />
          <span className="text-sm font-semibold">Support Now</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
